import { TypeAnn_DIVER_G2 } from './../../models/TypeAnn_DIVER_G2';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step2 } from '../../../../../shared/models/component-messages/diveAT/step2';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { CTRL_426 } from '../../../../validators/426/ctrl426';
import { CTRL_427 } from '../../../../validators/427/ctrl427';
import { CTRL_429 } from '../../../../validators/429/ctrl429';
import { AvisDataTransferService } from '../../../../../shared/services/avis-data-transfer.service';
import { CanNavigateInStepperService } from '../../../../../shared/services/can-navigate-in-stepper.service';

@Component({
	selector: 'app-step2',
	templateUrl: './step2.component.html'
})
export class Step2Component implements OnInit {

	private LOG: LogService = new LogService(Step2Component);

	@Input() attribution: TypeAnn_DIVER_G2;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() uid = '';
	@Input() linkForRouter: string;

	public step2 = new Step2();

	public radioButtonValue: string;
	public infructueux = RadioCheckBoxEnum.infructueux;
	public sansSuite = RadioCheckBoxEnum.sansSuite;
	public attribueUnique = RadioCheckBoxEnum.attribueUnique;
	public attribueLots = RadioCheckBoxEnum.attribueLots;
	public lotsInfructueux = RadioCheckBoxEnum.lotsInfructueux;

	public rg2 = '_STEP_ID_2_' + CTRL_426.id + '_1';
	public rg3 = '_STEP_ID_2_' + CTRL_427.id + '_1';
	public rg4 = '_STEP_ID_2_' + CTRL_429.id + '_1';

	public static dateAttribution: "_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_dateAttribution";
	public static attribue: "_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_SepSep_TypeResultatAttribution_SepAtt_infructueux";
	public static datePublication: "_SepSep_Attribution_SepSep_AvisInitial_SepSep_AvisInitialType_SepAtt_datePublication";

	constructor(public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private avisDataTransferService: AvisDataTransferService, private canNavigateInStepperService: CanNavigateInStepperService) { }

	ngOnInit(): void {
		const datePublication = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers.attribution.avisInitial.datePublication;
		this.parentForm.addControl(this.rg2, new FormControl({ rgCtrls: Step2Component.getCtrl_426Names_json(datePublication) }));
		this.parentForm.addControl(this.rg3, new FormControl({ rgCtrls: Step2Component.getCtrl_427Names_json() }));
		this.parentForm.addControl(this.rg4, new FormControl({ rgCtrls: Step2Component.getCtrl_429Names_json() }));
		this.radioButtonValue = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers.attribution.resultatAttribution;
		if (this.canNavigateInStepperService.isAvisLierNational && !this.canNavigateInStepperService.isEdit 
			&& this.attribution.autresInformations.dateAttribution === this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers.attribution.avisInitial.datePublication) {
			if (this.attribution && this.attribution.autresInformations.dateAttribution) {
				this.attribution.autresInformations.dateAttribution = '';
			}
		}

	const date = this.attribution?.autresInformations?.dateAttribution;
	if (date) {
	  this.parentForm.get(this.getUidTypeAutresInfosATTR() + '_SepAtt_dateAttribution')?.setValue(date);
	}
}

	isNotEmptyOrNullOrUndefined(value): boolean {
		return (value !== undefined && value !== null && value !== '');
	}

	public getUid() {
		return this.uid + '_SepSep_TypeAnn_DIVER_G2';
	}

	public getUidDescriptionReduite() {
		return this.uid + '_SepSep_TypeAnn_DIVER_G2_SepSep_DescriptionReduite';
	}

	public getUidTypeAutresInfosATTR() {
		return this.uid + '_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR';
	}

	public getUidTypeMontant() {
		return this.getUidTypeAutresInfosATTR() + '_SepSep_valeurTotaleEstimee_SepSep_TypeMontant';
	}

	public getUidAttribution() {
		return this.uid + '_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution';
	}

	public static getCtrl_426Names_json(datePublication): any {
		return { dateAttribution: "_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_dateAttribution", datePublication: datePublication };
	}

	public static getCtrl_427Names_json(): any {
		return { dateAttribution: "_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_dateAttribution" };
	}

	public static getCtrl_429Names_json(): any {
		return { attribue: "_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_SepSep_TypeResultatAttribution_SepAtt_infructueux", dateAttribution: "_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_dateAttribution" };
	}

}
